module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'cw-navSituation\' style="display: inline-flex;">\r\n    <div class=\'cw-liensNavegation\'>\r\n        <a class="linkVueJournee" style="display: block; margin-bottom: 5px;"">\r\n            <span class=" menuText cw-navSituation__lien">'+
((__t=(i18n.t('suivicollab.menuVueJournee')))==null?'':__t)+
'</span>\r\n        </a>\r\n        <a class="linkSituation" style="display: block; margin-bottom: 5px;"">\r\n            <span class=" menuText cw-navSituation__lien">'+
((__t=(i18n.t('fichecollab.menuSituation')))==null?'':__t)+
'</span>\r\n        </a>\r\n    </div>\r\n    <div style="display: flex;">\r\n        <div class="cw-navigation-suivicoll" style="align-self: flex-end;">\r\n            <span class="cwMenuButton btn btn-secondary cw-btn__navSuiviColl">\r\n                '+
((__t=(UTILS.getSVGIcon('fleche_haut','',12)))==null?'':__t)+
'\r\n            </span>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};
